var _effectorFileName = "/builds/gmini/front-ui-kit/src/FormulaInput/parse.ts";
import { endRe, escapeIdEnd, escapeIdStart, fullRe, startRe } from './constants';
const SPEC_SYMBOL = '__SPECIAL_SYMBOL__';
var ItemType;

(function (ItemType) {
  ItemType["PROPERTY"] = "PROPERTY";
  ItemType["STRING"] = "STRING";
})(ItemType || (ItemType = {}));

export function parseFormulaToSlate(src, properties, allProperties) {
  const preparedStr = src.replace(startRe, `${SPEC_SYMBOL}$&`).replace(endRe, `$&${SPEC_SYMBOL}`);
  const strings = preparedStr.split(SPEC_SYMBOL);
  const items = strings.filter(Boolean).map(str => {
    var _m$groups;

    const m = str.match(fullRe);
    const val = m === null || m === void 0 ? void 0 : (_m$groups = m.groups) === null || _m$groups === void 0 ? void 0 : _m$groups.value;

    if (val) {
      const id = JSON.parse(val);
      const payload = properties.find(p => p.id === id);

      if (!payload) {
        throw new Error(`Not found property by id === "${id}"`);
      }

      const onlyInFormula = allProperties.every(p => p.id !== id);
      return {
        type: ItemType.PROPERTY,
        value: payload.name,
        payload: { ...payload,
          onlyInFormula
        }
      };
    }

    return {
      type: ItemType.STRING,
      value: str,
      payload: {}
    };
  });
  const result = items.map(item => {
    if (item.type === ItemType.STRING) {
      return {
        text: item.value
      };
    }

    return {
      type: 'mention',
      property: item.payload,
      children: [{
        text: ''
      }]
    };
  });

  if (result.length > 0) {
    result.push({
      text: ' '
    });
  }

  return [{
    text: ''
  }, ...result];
}
export function serializeSlateToFormula(root) {
  let result = '';
  let hasSpecialChar = false;

  function recursive(nodes) {
    nodes.forEach(n => {
      switch (n.type) {
        case 'mention':
          {
            const node = n;
            result += `${escapeIdStart}${node.property.id}${escapeIdEnd}`;
            return;
          }
      }

      if (n.text) {
        const txt = n.text;
        result += txt;

        if (txt.includes(escapeIdStart) || txt.includes(escapeIdEnd)) {
          hasSpecialChar = true;
        }
      }

      if (n.children) {
        recursive(n.children);
      }
    });
  }

  recursive(root);
  return {
    result: result.trim(),
    hasSpecialChar
  };
}